// extracted by mini-css-extract-plugin
export default {"count":"NavBadge_count__uKAn6","setup":"NavBadge_setup__FUSm3"};